<template>
    <div>
        <div v-if="loading" class="loading_page">
            <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>
        
        <div v-if="items">
            <app-timeline>

                <div v-for="item in items" :key="item.day">
                    <h3 class="font-weight-bolder  text-center">{{ item.day }}</h3>
                    <div v-for="event in item.events" :key="event.id" class="event-element">
                        <li class="timeline-item timeline-variant-primary"
                            > 
                            <div  class=" timeline-item-icon-large d-flex align-items-center justify-content-center rounded-circle">
                                <div :class="getEventImg(event.type).rotate">
                                    <img :src="getEventImg(event.type).img" width="30" height="30">
                                </div>
                            
                            </div>
                        
                            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                            <h6 v-text="$t(event.type)" />
                            <small class="timeline-item-time text-nowrap text-muted" v-text="event.time" />
                            <a v-if="event.point!==''">
                              <img width="20px" :src="require('@/assets/points/marker.png')"  alt="" @click="$emit('getEventPoint',event)">
                            </a>
                            <img v-else width="20px" :src="require('@/assets/points/notfound.png')"  alt="" >
                            <a v-if="has_cam"><img width="20px" src="/cam/cam-icon-black.svg"  alt="" @click="$emit('playbackEvent',event)"></a>


                            </div>
                             <p class="mb-0" v-text="event.geofence" />
                                                
                            
                            </li>
                    </div>


                </div>

            </app-timeline>
        </div>

    </div>
</template>
  
<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'


import { BCollapse, BButton, VBToggle, BCard,BTabs, BTab } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { OrbitSpinner } from 'epic-spinners'
export default {
    components: {
        AppTimeline,
        AppTimelineItem,
        BButton,
        BCard,
        BCollapse,
        OrbitSpinner,
        BTabs, BTab
    },
    directives: {
        'b-toggle': VBToggle,
        Ripple,
    },
    props: {

        items: {
            type: Array,
            default: []
        },
        generalInfo: {
            type: Object,
            default: {}
        },
        has_cam: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getEventIcon(eventType) {
            switch (eventType) {
                case "geofenceEnter":
                    return { icon: "ArrowRightIcon", variant: "success" }
                    break;
                case "geofenceExit":

                    return { icon: "ArrowLeftIcon", variant: "warning" }
                    break;
            }
        },
        getEventImg(eventType) {
            switch (eventType) {
                case "geofenceEnter":
                    return { img: require('@/assets/markers/geofnce_events/geofenceEnter.svg'), rotate: 'rotate-0' }
                    break;
                case "geofenceExit":

                    return { img: require('@/assets/markers/geofnce_events/geofenceExit.svg'), rotate: 'rotate-0' }
                    break;
            }
        }



    }
}
</script>
<style scoped>
.events-btn {
    width: 100%;
    background-color: white;
    margin-top: -16px;
    margin-bottom: -16px;

}

.event-element {
    margin-bottom: 2rem;
}

.app-timeline {
    /* overflow: scroll;
    height: 400px; */
    padding: 5%
}
</style>
<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include'; // Bootstrap includes
@import '~@core/scss/base/components/include'; // Components includes

// Color palettes
@import '~@core/scss/base/core/colors/palette-variables.scss';

$timeline-border-color: $border-color;

/* Generate:
*  Apply background color to dot
*/
@each $color_name, $color in $colors {
  @each $color_type, $color_value in $color {
    @if $color_type== 'base' {
      .timeline-variant-#{$color_name} {
        &.timeline-item-fill-border-#{$color_name} {
          border-color: $color_value !important;
          &:last-of-type {
            &:after {
              background: linear-gradient($color_value, $white);
            }
          }
        }
        .timeline-item-point {
          background-color: $color_value;

          &:before {
            background-color: rgba($color_value, 0.12);
          }
        }

        .timeline-item-icon {
          color: $color_value;
          border: 1px solid $color_value;
        }
      }
    }
  }
}

.timeline-item {
  padding-left: 2.5rem;
  position: relative;
  &:not(:last-of-type) {
    padding-bottom: 2rem;
    border-left: 1px solid $timeline-border-color;
  }

  // This gives shade to last timeline-item but isn't that revolutionary
  &:last-of-type {
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 1px;
      height: 100%;
     
       background: linear-gradient(black, $white);
      margin-bottom: -2rem;
    }
  }

  .timeline-item-point {
    position: absolute;
    left: -6px;
    width: 12px;
    height: 12px;
    top: 0;
    border-radius: 50%;
    z-index: 1;

    &:before {
      content: '';
      z-index: 1;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      position: absolute;
      top: -4px;
      left: -4px;
      bottom: 0;
      right: 0;
    }
  }

  .timeline-item-icon {
    position: absolute;
    left: -12px;
    top: 0;
    width: 24px;
    height: 24px;
    background-color: $white;
    z-index: 1;
  }
  .timeline-item-icon-large{
    position: absolute;
    left: -14px;
    top: 0;
    width: 24px;
    height: 24px;
    
    z-index: 1;
  }
}

// *===============================================---*
// *--------- Dark Layout ---------------------------------------*
// *===============================================---*

.dark-layout {
  .timeline-item {
    &:last-of-type {
      &:after {
        background: linear-gradient($theme-dark-border-color, $theme-dark-card-bg);
      }
    }
    &:not(:last-of-type) {
      border-left-color: $theme-dark-border-color;
    }

    .timeline-item-icon {
      background-color: $theme-dark-card-bg;
    }
  }
}

</style>
